module.exports = __webpack_public_path__ + "img/norway-cardiovascular-diseases-female.25c74633.png";